<template>
  <div class="d-flex align-start justify-center py-4 ">
    <div class="w-100" style="position:relative;">
      <template v-if="data.type === 'DEPOSIT'">
        <template v-if="category === 'IRR'">
          <div class="w-100 mx-auto">
            <v-card
              class="card d-flex flex-column align-center pa-4 px-md-10 pb-md-8 mt-10 w-100 mx-auto"
              color="gray10"
              flat
              :width="$vuetify.breakpoint.smAndDown ? 400 : 600"
            >
              <div class="d-flex align-center flex-column">
                <img
                  :src="data.from_currency.logo_main"
                  alt=""
                  width="60"
                  height="60"
                  class="iso-logo"
                />
                <div class="status-in-table ">
                  <span class="considering-status font-Regular-12">
                    {{ data.status.locale }}
                  </span>
                </div>
              </div>

              <v-card
                class="card d-flex flex-column align-center pa-3 mt-8 w-100"
                color="gray8"
              >
                <ul class="w-100 pa-0">
                  <li class="withdraw-item">
                    <span class="gray2--text">
                      {{ $t("corporateAccount.signCrypto.currencyType") }}
                    </span>
                    <span>{{ data.from_currency.name }}</span>
                  </li>
                  <li class="withdraw-item">
                    <span class="gray2--text">
                      {{ $t("corporateAccount.signCrypto.youSend") }}
                    </span>
                    <div class="price-style">
                      <span class="font-Regular-18">{{
                        data.from_amount
                      }}</span>
                      <span class="font-Regular-12">{{
                        data.from_currency.name
                      }}</span>
                    </div>
                  </li>
                  <li class="withdraw-item">
                    <span class="gray2--text">
                      {{
                        $t(
                          "corporateAccount.signCrypto.destinationWalletAddress"
                        )
                      }}
                    </span>
                    <span>{{ data.to_address }}</span>
                  </li>
                  <li class="withdraw-item">
                    <span class="gray2--text">
                      {{ $t("corporateAccount.signCrypto.networkType") }}
                    </span>
                    <span>{{ data.network.title }}</span>
                  </li>
                  <li class="withdraw-item">
                    <span class="gray2--text">
                      {{ $t("corporateAccount.signCrypto.amountExcludingFee") }}
                    </span>
                    <div class="price-style">
                      <span>{{ data.gross_to_amount }}</span>
                      <span>{{ data.from_currency.name }}</span>
                    </div>
                  </li>
                  <li class="withdraw-item">
                    <span class="gray2--text">
                      {{ $t("corporateAccount.signCrypto.fee") }}
                    </span>
                    <div class="price-style">
                      <span>{{ data.transfer_fee }}</span>
                      <span>{{ data.from_currency.name }}</span>
                    </div>
                  </li>
                  <li class="withdraw-item">
                    <span class="gray2--text">
                      {{ $t("corporateAccount.signCrypto.description") }}
                    </span>
                    <span>{{ data.description }}</span>
                  </li>
                </ul>
              </v-card>

              <div class="mt-4 w-100">
                <MemberList
                  bg="gray8"
                  :members="data.corporateMemberVerifications"
                  type="SUBMIT"
                />
              </div>

              <v-row class="w-100 mt-1" v-if="!data.is_current_member_accepted">
                <v-col cols="12" md="6" class="px-0 pe-1">
                  <v-btn
                    outlined
                    x-large
                    block
                    outline
                    color="primary"
                    @click="cancelDialog = true"
                  >
                    {{ $t("corporateAccount.signCrypto.cancelTransaction") }}
                  </v-btn>
                </v-col>
                <v-col cols="12" md="6" class="px-0 ps-1">
                  <v-btn x-large block color="primary" @click="acceptHandler">
                    {{ $t("corporateAccount.signCrypto.submitSignature") }}
                  </v-btn>
                </v-col>
              </v-row>
            </v-card>
          </div>
        </template>
        <template v-if="category === 'cryptoCurrency'">
          <div class="w-100 mx-auto">
            <v-card
              class="card d-flex flex-column align-center pa-4 px-md-10 pb-md-8 mt-10 w-100 mx-auto"
              color="gray10"
              flat
              :width="$vuetify.breakpoint.smAndDown ? 400 : 600"
            >
              <div class="d-flex align-center flex-column">
                <img
                  :src="data.from_currency.logo_main"
                  alt=""
                  width="60"
                  height="60"
                  class="iso-logo"
                />
                <div class="status-in-table ">
                  <span class="considering-status font-Regular-12">
                    {{ data.status.locale }}
                  </span>
                </div>
              </div>

              <v-card
                class="card d-flex flex-column align-center pa-3 mt-8 w-100"
                color="gray8"
              >
                <ul class="w-100 pa-0">
                  <li class="withdraw-item">
                    <span class="gray2--text">
                      {{ $t("corporateAccount.signCrypto.currencyType") }}
                    </span>
                    <span>{{ data.from_currency.name }}</span>
                  </li>
                  <li class="withdraw-item">
                    <span class="gray2--text">
                      {{ $t("corporateAccount.signCrypto.youSend") }}
                    </span>
                    <div class="price-style">
                      <span class="font-Regular-18">{{
                        data.from_amount
                      }}</span>
                      <span class="font-Regular-12">{{
                        data.from_currency.name
                      }}</span>
                    </div>
                  </li>
                  <li class="withdraw-item">
                    <span class="gray2--text">
                      {{
                        $t(
                          "corporateAccount.signCrypto.destinationWalletAddress"
                        )
                      }}
                    </span>
                    <span>{{ data.to_address }}</span>
                  </li>
                  <li class="withdraw-item">
                    <span class="gray2--text">
                      {{ $t("corporateAccount.signCrypto.networkType") }}
                    </span>
                    <span>{{ data.network.title }}</span>
                  </li>
                  <li class="withdraw-item">
                    <span class="gray2--text">
                      {{ $t("corporateAccount.signCrypto.amountExcludingFee") }}
                    </span>
                    <div class="price-style">
                      <span>{{ data.gross_to_amount }}</span>
                      <span>{{ data.from_currency.name }}</span>
                    </div>
                  </li>
                  <li class="withdraw-item">
                    <span class="gray2--text">
                      {{ $t("corporateAccount.signCrypto.fee") }}
                    </span>
                    <div class="price-style">
                      <span>{{ data.transfer_fee }}</span>
                      <span>{{ data.from_currency.name }}</span>
                    </div>
                  </li>
                  <li class="withdraw-item">
                    <span class="gray2--text">
                      {{ $t("corporateAccount.signCrypto.description") }}
                    </span>
                    <span>{{ data.description }}</span>
                  </li>
                </ul>
              </v-card>

              <div class="mt-4 w-100">
                <MemberList
                  bg="gray8"
                  :members="data.corporateMemberVerifications"
                  type="SUBMIT"
                />
              </div>

              <v-row class="w-100 mt-1" v-if="!data.is_current_member_accepted">
                <v-col cols="12" md="6" class="px-0 pe-1">
                  <v-btn
                    outlined
                    x-large
                    block
                    outline
                    color="primary"
                    @click="cancelDialog = true"
                  >
                    {{ $t("corporateAccount.signCrypto.cancelTransaction") }}
                  </v-btn>
                </v-col>
                <v-col cols="12" md="6" class="px-0 ps-1">
                  <v-btn x-large block color="primary" @click="acceptHandler">
                    {{ $t("corporateAccount.signCrypto.submitSignature") }}
                  </v-btn>
                </v-col>
              </v-row>
            </v-card>
          </div>
        </template>
      </template>
      <template v-if="data.type === 'WITHDRAW'">
        <template v-if="category === 'IRR'">
          <div class="w-100 mx-auto">
            <v-card
              class="card d-flex flex-column align-center justify-center pa-4 px-md-10 pb-md-8 mt-10 w-100 mx-auto"
              color="gray10"
              flat
              max-width="800"
            >
              <div class="d-flex align-center flex-column">
                <img
                  :src="data.from_currency.logo_main"
                  alt=""
                  width="60"
                  height="60"
                  class="iso-logo"
                />
                <div class="status-in-table ">
                  <span class="considering-status font-Regular-12">
                    {{ data.status.locale }}
                  </span>
                </div>
              </div>

              <v-card
                class="card d-flex flex-column align-center pa-3 mt-8 w-100"
                color="gray8"
              >
                <ul class="w-100 pa-0">
                  <li class="withdraw-item">
                    <span class="gray2--text">
                      {{ $t("corporateAccount.permissionsCartable.requester") }}
                    </span>
                    <span>{{ data.from_currency.name }}</span>
                  </li>
                  <li class="withdraw-item">
                    <span class="gray2--text">
                      {{ $t("corporateAccount.signCrypto.youReceive") }}
                    </span>
                    <div class="price-style">
                      <span class="font-Regular-18">{{
                        data.from_amount
                      }}</span>
                      <span class="font-Regular-12">{{
                        data.from_currency.name
                      }}</span>
                    </div>
                  </li>
                  <li class="withdraw-item">
                    <span class="gray2--text">
                      {{ $t("corporateAccount.signCrypto.orderNumber") }}
                    </span>
                    <span>{{ data.to_address }}</span>
                  </li>
                  <li class="withdraw-item">
                    <span class="gray2--text">
                      {{ $t("corporateAccount.signCrypto.accountHolderName") }}
                    </span>
                    <span>{{ data.network.title }}</span>
                  </li>
                  <li class="withdraw-item">
                    <span class="gray2--text">
                      {{ $t("corporateAccount.signCrypto.shebaNumber") }}
                    </span>
                    <div class="price-style">
                      <span>{{ data.gross_to_amount }}</span>
                      <span>{{ data.from_currency.name }}</span>
                    </div>
                  </li>
                  <!--                <li class="withdraw-item">-->
                  <!--                  <span class="gray2&#45;&#45;text">-->
                  <!--                    توضیحات رضا شاهگردی-->
                  <!--                  </span>-->
                  <!--                  <div class="price-style">-->
                  <!--                    <span>{{ data.transfer_fee }}</span>-->
                  <!--                    <span>{{ data.from_currency.name }}</span>-->
                  <!--                  </div>-->
                  <!--                </li>-->
                </ul>
              </v-card>

              <div class="mt-4 w-100">
                <MemberList
                  bg="gray8"
                  :members="data.corporateMemberVerifications"
                  type="SUBMIT"
                />
              </div>

              <v-row class="w-100 mt-1" v-if="!data.is_current_member_accepted">
                <v-col cols="12" md="6" class="px-0 pe-1">
                  <v-btn
                    outlined
                    x-large
                    block
                    outline
                    color="primary"
                    @click="cancelDialog = true"
                  >
                    {{ $t("corporateAccount.signCrypto.cancelTransaction") }}
                  </v-btn>
                </v-col>
                <v-col cols="12" md="6" class="px-0 ps-1">
                  <v-btn x-large block color="primary" @click="acceptHandler">
                    {{ $t("corporateAccount.signCrypto.submitSignature") }}
                  </v-btn>
                </v-col>
              </v-row>
            </v-card>
          </div>
        </template>
        <template v-if="category === 'cryptoCurrency'">
          <div class="w-100 mx-auto">
            <v-card
              class="card d-flex flex-column align-center justify-center pa-4 px-md-10 pb-md-8 mt-10 w-100 mx-auto"
              color="gray10"
              flat
              max-width="800"
            >
              <div class="d-flex align-center flex-column">
                <img
                  :src="data.from_currency.logo_main"
                  alt=""
                  width="60"
                  height="60"
                  class="iso-logo"
                />
                <div class="status-in-table ">
                  <span class="considering-status font-Regular-12">
                    {{ data.status.locale }}
                  </span>
                </div>
              </div>

              <v-card
                class="card d-flex flex-column align-center pa-3 mt-8 w-100"
                max-width="800"
                color="gray8"
              >
                <ul class="w-100 pa-0">
                  <li class="withdraw-item">
                    <span class="gray2--text">
                      {{ $t("corporateAccount.signCrypto.currencyType") }}
                    </span>
                    <span>{{ data.from_currency.name }}</span>
                  </li>
                  <li class="withdraw-item">
                    <span class="gray2--text">
                      {{ $t("corporateAccount.signCrypto.youSend") }}
                    </span>
                    <div class="price-style">
                      <span class="font-Regular-18">{{
                        data.from_amount
                      }}</span>
                      <span class="font-Regular-12">{{
                        data.from_currency.name
                      }}</span>
                    </div>
                  </li>
                  <li class="withdraw-item">
                    <span class="gray2--text">
                      {{
                        $t(
                          "corporateAccount.signCrypto.destinationWalletAddress"
                        )
                      }}
                    </span>
                    <span>{{ data.to_address }}</span>
                  </li>
                  <li class="withdraw-item">
                    <span class="gray2--text">
                      {{ $t("corporateAccount.signCrypto.networkType") }}
                    </span>
                    <span>{{ data.network.title }}</span>
                  </li>
                  <li class="withdraw-item">
                    <span class="gray2--text">
                      {{ $t("corporateAccount.signCrypto.amountExcludingFee") }}
                    </span>
                    <div class="price-style">
                      <span>{{ data.gross_to_amount }}</span>
                      <span>{{ data.from_currency.name }}</span>
                    </div>
                  </li>
                  <li class="withdraw-item">
                    <span class="gray2--text">
                      {{ $t("corporateAccount.signCrypto.fee") }}
                    </span>
                    <div class="price-style">
                      <span>{{ data.transfer_fee }}</span>
                      <span>{{ data.from_currency.name }}</span>
                    </div>
                  </li>
                  <li class="withdraw-item">
                    <span class="gray2--text">
                      {{ $t("corporateAccount.signCrypto.description") }}
                    </span>
                    <span>{{ data.description }}</span>
                  </li>
                </ul>
              </v-card>

              <div
                class="mt-4 w-100"
                v-if="data.corporateMemberVerifications.length > 0"
              >
                <MemberList
                  bg="gray8"
                  :members="data.corporateMemberVerifications"
                  type="SUBMIT"
                />
              </div>

              <v-row class="w-100 mt-1" v-if="!data.is_current_member_accepted">
                <v-col cols="12" md="6" class="px-0 pe-1">
                  <v-btn
                    outlined
                    x-large
                    block
                    outline
                    color="primary"
                    @click="cancelDialog = true"
                  >
                    {{ $t("corporateAccount.signCrypto.cancelTransaction") }}
                  </v-btn>
                </v-col>
                <v-col cols="12" md="6" class="px-0 ps-1">
                  <v-btn x-large block color="primary" @click="acceptHandler">
                    {{ $t("corporateAccount.signCrypto.submitSignature") }}
                  </v-btn>
                </v-col>
              </v-row>
            </v-card>
          </div>
        </template>
      </template>
      <div
        class="d-flex align-center"
        style="position:absolute;right: 22%;top: 10%"
        :class="[$vuetify.breakpoint.mdAndDown && 'd-none']"
      >
        <v-btn
          depressed
          icon
          height="20"
          width="20"
          to="/history/transaction/withdrawals?category=cryptoCurrency"
        >
          <v-icon
            size="35"
            clr="var(--v-gray2-base)"
            :class="{ 'transfor-x': $vuetify.rtl }"
          >
            $arrow
          </v-icon>
        </v-btn>

        <span class="ms-10 font-Regular-16">{{ $t("shared.back") }}</span>
      </div>
    </div>

    <v-dialog v-model="cancelDialog" max-width="400">
      <v-card
        class="d-flex flex-column align-center justify-center pa-4 px-md-8 pt-md-16 pb-md-10 gray10"
      >
        <v-icon size="68" clr="var(--v-error-base)">$cancelOrder</v-icon>

        <span class="font-Bold-20 mt-6">
          {{ $t("corporateAccount.signCrypto.cancelTransaction") }}</span
        >
        <p class=" font-Regular-17 gray2--text mt-6">
          {{ $t("corporateAccount.signCrypto.revokeConfirmation") }}
        </p>

        <!--        <v-textarea-->
        <!--          v-model="cardNumber"-->
        <!--          type="text"-->
        <!--          color="primaryX"-->
        <!--          background-color="var(&#45;&#45;v-field-base)"-->
        <!--          class="custom-form-control  w-100"-->
        <!--          placeholder="یادداشت (اختیاری)"-->
        <!--        ></v-textarea>-->

        <v-btn x-large color="primary" block @click="declineHandler">
          {{
            $t(
              "corporateAccount.signCreate.revokeLegalAccountPermissionConfirmButton"
            )
          }}</v-btn
        >
        <v-btn
          x-large
          outlined
          color="primary"
          block
          class="mt-4"
          @click="cancelDialog = false"
        >
          {{ $t("shared.cancelAction") }}
        </v-btn>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import MemberList from "@/components/Shared/LegalEntity/MemberList.vue";
import legalService from "@/services/modules/legalService";

export default {
  components: { MemberList },
  props: ["data"],
  data() {
    return {
      cancelDialog: false,
      category: this.$route.query.category
    };
  },

  mounted() {},

  methods: {
    declineHandler() {
      legalService
        .reviewOrderByMember(this.$route.params.id, { is_accepted: 0 })
        .then(() => {
          this.$router.push(
            `/history/transaction/withdrawals?category=${this.category}`
          );
        });
    },
    acceptHandler() {
      legalService
        .reviewOrderByMember(this.$route.params.id, { is_accepted: 1 })
        .then(() => {
          this.$router.push(
            `/history/transaction/withdrawals?category=${this.category}`
          );
        });
    }
  }
};
</script>

<style scoped lang="scss">
.d-none {
  display: none !important;
}
.iso-logo {
  transform: translateY(-50%);
}
.withdraw-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 0;
  &:not(:last-child) {
    border-bottom: 1px solid var(--v-gray6-base);
  }
}
</style>
